module.exports = __WEBPACK_EXTERNAL_MODULE_373__;


//////////////////
// WEBPACK FOOTER
// external "xmldom"
// module id = 373
// module chunks = 0